/**
 * Registro de idiomas del sitio.
 *
 * **Este arreglo es el único lugar que hay que tocar para agregar un idioma.**
 * El selector se dibuja iterándolo, la detección del navegador busca aquí, y
 * `Mensajes` obliga a que el diccionario nuevo esté completo. Agregar francés
 * es: crear `locales/fr/`, importarlo en `locales/index.ts` y añadir su entrada
 * aquí. Ningún componente cambia.
 */

export interface Idioma {
  /** Código ISO 639-1. Es lo que se guarda en `localStorage` y en `<html lang>`. */
  codigo: string;
  /** Cómo se llama el idioma *en ese idioma*: así lo reconoce quien lo busca. */
  etiqueta: string;
  /** Abreviatura para el botón cuando no cabe la etiqueta completa. */
  corto: string;
  /**
   * Locale completo para `Intl` (fechas, números, moneda). No siempre coincide
   * con el código: el español del sitio es el de México, no el de España.
   */
  locale: string;
}

export const IDIOMAS: Idioma[] = [
  { codigo: 'es', etiqueta: 'Español', corto: 'ES', locale: 'es-MX' },
  { codigo: 'en', etiqueta: 'English', corto: 'EN', locale: 'en-US' },
];

/**
 * Idioma al que se cae cuando no hay nada guardado y el navegador no habla
 * ninguno de los nuestros. Es español porque el tráfico del sitio es mexicano.
 */
export const IDIOMA_POR_OMISION = 'es';

/**
 * Idioma en el que se escribe el contenido original del sitio.
 *
 * Hoy coincide con `IDIOMA_POR_OMISION`, pero son cosas distintas y conviene
 * poder cambiar una sin la otra: el respaldo es "qué enseñar si no sé qué
 * quieres", y este es "cuál versión manda". Importa en los documentos legales,
 * donde el español es el texto vinculante y las demás traducciones son de
 * cortesía; `LegalDocumentPage` lo dice en pantalla comparando contra esto.
 */
export const IDIOMA_ORIGINAL = 'es';

export function buscarIdioma(codigo: string | null | undefined): Idioma | undefined {
  if (!codigo) return undefined;
  return IDIOMAS.find((idioma) => idioma.codigo === codigo);
}

export function idiomaPorOmision(): Idioma {
  // El registro nunca está vacío, pero el tipo no lo sabe.
  return buscarIdioma(IDIOMA_POR_OMISION) ?? IDIOMAS[0];
}
